import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DynamicContentItem, DynamicContentComponent } from "../components/DynamicContentComponent";
import { ImageComponent } from "../components/ImageComponent";
import { getPath, Paths } from '../utils/paths';
import { AccordionComponent } from "../components/AccordionComponent";
import { BreadcrumbComponent, BreadCrumProps } from "../components/BreadcrumComponent";
import { useSearchParams } from "react-router-dom";

export const Services = () => {
  const { t, ready } = useTranslation("services");

  if (!ready) return "loading translations...";

  const breadCrums = t("breadcrums", { returnObjects: true }) as BreadCrumProps[];

  const [expanded, setExpanded] = React.useState<string | false>('accordion1');

  const [searchParams] = useSearchParams();
    
  const topDynamicContent = t("topContent", { returnObjects: true }) as DynamicContentItem[];
  const accordionSoftwareDevelopmentContent = t("serviceSoftwareDevelopment", { returnObjects: true }) as DynamicContentItem[];
  const accordionTransformationtContent = t("serviceTransformation", { returnObjects: true }) as DynamicContentItem[];
  const accordionPipelineContent = t("servicePipeline", { returnObjects: true }) as DynamicContentItem[];  
  const accordionAnalysisContent = t("serviceAnalysis", { returnObjects: true }) as DynamicContentItem[];  
  const accordionArchitectureContent = t("serviceArchitecture", { returnObjects: true }) as DynamicContentItem[];  

  const handleChangeAccordion = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };
  
  useEffect(() => {
    // check for open accordion param
    const queryParams = new URLSearchParams(searchParams);
    if (queryParams.get('openaccordion')) {
      if (queryParams.get('openaccordion') !== expanded) {
        setExpanded(queryParams.get('openaccordion') || '')
      }
    }
  }, [searchParams]);

  return (
    <>
      <ImageComponent
        imageSrc={`${getPath(Paths.IMAGES_MISC, false)}/notes-heli-ipad.jpg`}
        imageProps={{
          width: "100%",
          height: "auto"
        }}
      />
      <BreadcrumbComponent breadcrums={breadCrums} />
      <Box>
        <DynamicContentComponent
          items={topDynamicContent}
          key={"services"}
        />
      </Box>

       <AccordionComponent key={"services-sw-dev"} title={t("serviceSoftwareDevelopmentTitle")} headerImage={`${getPath(Paths.IMAGES_VENDORS, false)}/java_logo.svg`} expanded={expanded == "accordion1"} onChange={handleChangeAccordion("accordion1")}>
        <DynamicContentComponent
          items={accordionSoftwareDevelopmentContent}
          key={"services-software-development"}
          containerType="Box"
        />
      </AccordionComponent>

      <AccordionComponent key={"services-trans"} title={t("serviceTransformationTitle")} headerImage={`${getPath(Paths.IMAGES_VENDORS, false)}/kubernetes.png`} expanded={expanded == "accordion2"} onChange={handleChangeAccordion("accordion2")}>
        <DynamicContentComponent
          items={accordionTransformationtContent}
          key={"services-transformation"}
          containerType="Box"
        />
      </AccordionComponent>

      <AccordionComponent key={"services-pipeline"} title={t("servicePipelineTitle")} headerImage={`${getPath(Paths.IMAGES_VENDORS, false)}/argocd.svg`} expanded={expanded == "accordion3"} onChange={handleChangeAccordion("accordion3")}>
        <DynamicContentComponent
          items={accordionPipelineContent}
          key={"services-pipeline"}
          containerType="Box"
        />
      </AccordionComponent>

      <AccordionComponent key={"services-analysis"} title={t("serviceAnalysisTitle")} headerImage={`${getPath(Paths.IMAGES_LOGO, false)}/logo_gear.svg`} expanded={expanded == "accordion4"} onChange={handleChangeAccordion("accordion4")}>
        <DynamicContentComponent
          items={accordionAnalysisContent}
          key={"services-analysis"}
          containerType="Box"
        />
      </AccordionComponent>

      <AccordionComponent key={"services-architecture"} title={t("serviceArchitectureTitle")} headerImage={`${getPath(Paths.IMAGES_LOGO, false)}/logo_gear.svg`} expanded={expanded == "accordion5"} onChange={handleChangeAccordion("accordion5")}>
        <DynamicContentComponent
          items={accordionArchitectureContent}
          key={"services-architecture"}
          containerType="Box"
        />
      </AccordionComponent>
    </>
  );
};